var map = {
	"./image-1.webp": 932,
	"./image-10.jpeg": 428,
	"./image-11.jpeg": 640,
	"./image-2.webp": 208,
	"./image-3.webp": 193,
	"./image-4.webp": 958,
	"./image-5.webp": 453,
	"./image-6.webp": 209,
	"./image-7.webp": 141,
	"./image-8.webp": 896,
	"./image-9.webp": 332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 515;